<template>
  <div class="user-info-detail-wrapper">
    <display-navigation title="个人信息" path="user_info" />
    <div class="content-wrapper">
      <div class="avatar-wrapper">
        <van-image round :width="70" :height="70" :src="value.avatar" />
      </div>
      <van-field disabled size="large" label="姓名" :value="value.name" />
      <van-field
        disabled
        size="large"
        label="身份证"
        :value="value.identityNo"
      />
      <van-field
        required
        size="large"
        label="手机号"
        :maxlength="11"
        v-model="value.tel"
      />
      <van-field
        required
        size="large"
        label="游戏昵称"
        v-model="value.gameNickName"
      />
    </div>
    <div class="action-wrapper">
      <van-button
        block
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="handleSubmit"
        >确认修改</van-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { updateUserDetail } from '../../../api/api-user';
import DisplayNavigation from '../../../components/DisplayNavigation';

export default {
  components: {
    DisplayNavigation,
  },
  data() {
    return {
      value: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    this.value = this.user;
  },
  methods: {
    ...mapActions(['getUser']),
    handleChange(val) {
      this.value = parseFloat(val);
    },
    checkFields() {
      return new Promise((resolve, reject) => {
        const { tel, gameNickName } = this.value;
        if (!tel || tel.length !== 11) reject(new Error('手机号格式错误'));
        if (!gameNickName) reject(new Error('未输入游戏名称'));
        resolve(this.value);
      });
    },
    back() {
      this.$router.push({ name: 'user_info' });
    },
    async handleSubmit() {
      try {
        const data = await this.checkFields();
        this.loading = true;
        const feedback = await updateUserDetail(data);
        if (feedback) {
          await this.getUser();
          this.back();
        }
      } catch (e) {
        this.$toast.fail(e.message);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-detail-wrapper {
  background: #fff;
  .content-wrapper {
    padding: 24px 12px;
    .avatar-wrapper {
      text-align: center;
      margin-bottom: 12px;
    }
  }
  .action-wrapper {
    padding: 12px 24px 24px;
  }
}
</style>
